// Variety synonym canonicalization (client-side, for read-time grouping/equality).
//
// Some varieties are the same cultivar spelled differently — most famously
// Geisha / Gesha. Storage is normalized on write server-side, but grouping and
// equality here also canonicalize so equivalence holds even for rows not yet
// backfilled and for aliases added after a backfill.
//
// MIRROR: keep this alias map in sync with functions/lib/variety.ts and the
// backfill migration. Add GENUINE synonyms only (same cultivar, different
// spelling) — never merge distinct cultivars. Keys are lowercased + trimmed;
// values are the canonical display spelling.
const CANON: Record<string, string> = {
  gesha: "Geisha",
  geisha: "Geisha",
};

/** Canonical display spelling for a variety; unknown varieties are returned trimmed as-is. */
export function canonicalVariety(v: string): string {
  const key = v.trim().toLowerCase();
  return CANON[key] ?? v.trim();
}

/** Stable lowercased key for grouping/equality — merges synonyms and casing. */
export function varietyKey(v: string): string {
  return canonicalVariety(v).toLowerCase();
}
